module.exports = __webpack_public_path__ + "static/media/mothers with children.8e41e591.jpg";